import clsx from 'clsx';
import useTranslation from 'next-translate/useTranslation';

//hook
import useUserRole from '@/utils/hooks/user/useUserRole';
import { useUserGroupRestriction } from '@/utils/hooks/acl/useUserGroupRestriction';

// Components
import Icon from '@/components/base/Icon';
import Button from '@/components/base/Button';

type ActionsProps = {
    toggleGroupModal: () => void;
    toggleDeleteMultiple: () => void;
    unSelectAll: () => void;
    nbSelectedSocialProfiles: number;
    canDelete: boolean;
};

export function ActionsBar({
    toggleGroupModal,
    toggleDeleteMultiple,
    unSelectAll,
    nbSelectedSocialProfiles,
    canDelete
}: ActionsProps) {
    const { isTeamMember } = useUserRole();
    const { t } = useTranslation('socialprofiles');

    const { hasGroupPermission } = useUserGroupRestriction();

    return (
        <div
            className={clsx('flex items-center', {
                'justify-between': hasGroupPermission,
                'justify-end': !hasGroupPermission
            })}
            data-testid="actions-bar">
            {hasGroupPermission ? (
                <Button
                    onClick={toggleGroupModal}
                    size="sm"
                    className="space-x-3 px-5"
                    data-testid="button-group-modal">
                    <Icon icon="plus" />
                    <span>{t('groups.cta_modal_group', { count: nbSelectedSocialProfiles })}</span>
                </Button>
            ) : null}
            <div className="flex gap-x-3 text-xs">
                {isTeamMember ? null : (
                    <>
                        <button
                            data-testid="button-delete-modal"
                            onClick={toggleDeleteMultiple}
                            disabled={!canDelete}
                            className="text-icoRed disabled:cursor-not-allowed disabled:text-icoGray-500 disabled:dark:text-icoDarkMode-wolf">
                            {t('groups.cta_delete_selected_profiles')}
                        </button>
                        <span className="block h-6 w-px bg-icoGray-500 dark:bg-icoDarkMode-beton" />
                    </>
                )}

                <button
                    onClick={unSelectAll}
                    className="text-icoBlue"
                    data-testid="button-unselect-all">
                    {t('commons:unselect_all')}
                </button>
            </div>
        </div>
    );
}
